import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import { objectToFormData } from "../../utils";
import {
  Button, Form,
  Input,
  Menu,
  Modal,
  Select,
  Typography
} from "antd";
import { cards } from "../../actions/cards/cards";
import AddUser from "../../assets/icons/add_user.png";
import Table from "../Common/Table/Table";
import PageHeader from "../PageHeader";

import {
  PlusCircleOutlined, UploadOutlined
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { status } from "./Card";
import { hasAccess } from "../../utils";
import { GoPersonAdd } from "react-icons/go";
const { Option } = Select;

const CardInventory = () => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const cardsResponse = useSelector((state) => state.cards.cards || {});
  const history = useHistory();
  const dispatch = useDispatch();
  const { data: { response: { cards: cardsList = [] } = {} } = {} } =
    cardsResponse;

  const columns = [
    {
      title: "CRN",
      dataIndex: "card_reference_no",
      key: "card_reference_no",
      width: 150,
      render: (text, record) => <div className={`render_common_style status_${record?.status}`}>{text}</div>
    },
    // {
    //   title: "Card Number",
    //   dataIndex: "card_number",
    //   key: "card_number",
    //   width: 150,
    //   render: (text, record) => (
    //     <div>
    //       {record?.data?.maskCardNumber?.slice(
    //         record.data.maskCardNumber.length - 8
    //       )}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Employee ID",
    //   dataIndex: "employee_id",
    //   key: "employee_id",
    //   width: 150,
    //   render: (text, record) => <div>{record.employee_details?.employee_id}</div>,
    // },
    {
      title: "Employee Name",
      dataIndex: "employee_details",
      key: "employee_details",
      width: 300,
      render: (text, record) => <div>{record.employee_details?.name}</div>,
    },
    {
      title: "Employee Mobile",
      dataIndex: "emp_mobile",
      key: "emp_mobile",
      width: 250,
      render: (text, record) => <div>{record.employee_details?.mobile}</div>,
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      width: 200,
    },
    // {
    //   title: "Email",
    //   dataIndex: "description",
    //   key: "description",
    //   width: 200,
    //   render: (text, record) => <div>{record.employee_details?.email}</div>,
    // },
    // {
    //   title: "Total Balance",
    //   dataIndex: "balance",
    //   key: "balance",
    //   width: 150,
    // },
    // {
    //   title: "Issued On",
    //   dataIndex: "card_activated_on",
    //   key: "card_activated_on",
    //   width: 150,
    //   // render: (text) => <div>9 Sep'18</div>,
    // },
    {
      title: "Card Status",
      dataIndex: "status",
      key: "status",
      width: 200,
    },
    {
      title: "KYC Status",
      dataIndex: "kyc_flag",
      key: "kyc_flag",
      width: 150,
      render: (text) => (
        <div className={`status_text_${status[text]}`}>{text}</div>
      ),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      render: (text, record) => (
        <button
          className="arrowBackground"
          onClick={() => {
            history.push("/setting/users", {
              openAddNew: true,
              user: record,
            });
          }}
          disabled={!hasAccess("cards", "write")}
          style={{ padding: 5 }}
        >
          {/* <img src={AddUser} alt="text" width={16} height={14} /> */}
          <GoPersonAdd color="rgba(49, 65, 134, 1)" />
        </button>
      ),
    },
  ];

  React.useEffect(() => {
    dispatch(cards({ non_linked: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1" icon={<PlusCircleOutlined />}>
        Assign to employee
      </Menu.Item>
      <Menu.Item key="2" icon={<PlusCircleOutlined />}>
        Assign to branch
      </Menu.Item>
      <Menu.Item key="3" icon={<UploadOutlined />}>
        Bulk assign cards
      </Menu.Item>
    </Menu>
  );

  console.log(menu)

  // function handleButtonClick(e) {
  //   showModal();
  // }

  function handleMenuClick(e) {
    showModal();
  }

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Modal
        title={
          <Typography.Title level={4}>
            {selectedId ? "Edit Fields" : "Assign Cards"} &nbsp;
            <span className="text-small">Select user and assign</span>
          </Typography.Title>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal-small"
        }
      >
        <Form
          layout="vertical"
          // onFinish={formik.handleSubmit}
          className="settings_form"
        >
          <Form.Item label="From Branch">
            <Select
              style={{ width: 200 }}
              placeholder="Select Country"
            // onChange={(val) => handleCountryData(val)}
            // value={countryData}
            >
              <Option>Forgo (Master Org)</Option>
            </Select>
          </Form.Item>
          <Form.Item label="To Branch">
            <Select
              style={{ width: 200 }}
              placeholder="Select Country"
            // onChange={(val) => handleCountryData(val)}
            // value={countryData}
            >
              <Option>Paycraft Solutions</Option>
              <Option>Paycraft Info Ltd</Option>
            </Select>
          </Form.Item>
          <Form.Item label="No of cards">
            <Input placeholder="No of cards" />
          </Form.Item>
          <Form.Item label="Available cards in inventory - 10,430" />
          <Button
            key="1"
            htmlType="submit"
            className="formButton mt1 primaryButton"
          >
            Assign
          </Button>
          <Button
            key="2"
            className="cancelButton ml1 mt1"
          // onClick={() => props.handleCancel()}
          >
            Cancel
          </Button>
        </Form>
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Inventory`}
          navigation={{
            Home: hasAccess("dashboard", "read") || hasAccess("dashboard", "write") ? "/dashboard" : "",
            Cards: "/cards/",
            Inventory: "/card-inventory/",
          }}
        />
      </div>

      <Table
        rowKey="id"
        // rowSelection={{
        //   type: 'checkbox',
        //   // ...rowSelection,
        // }}
        placeholder={"Search By CRN, Name"}

        handleSearch={(value) => {
          dispatch(cards({ non_linked: true, search_key: value }));
        }}
        className="tableStyled admin cards"
        columns={columns}
        data={cardsList}
        isTopFilter={true}
        filter={true}
        isMore={true}
        pagination={{
          total: cardsResponse?.data?.total_records || 0,
          onChange: (pagee) =>
            dispatch(cards({ non_linked: true, page: pagee })),
        }}
        scroll={{ x: 970 }}
      />
    </>
  );
};

export default CardInventory;
